import { TWENTY_FIVE_SECONDS, TEN_MINUTES } from "Constants/TimeConstants";

export const LOW_THRESHOLD = 10; // when to show the alternative status colour and text
export const REFRESH_TIME = TEN_MINUTES; // time between checking backend for fresh copy
export const GRACE_PERIOD = TWENTY_FIVE_SECONDS; // grace period/cool-down before trying to get a fresh copy
export const STATUS_PAGES = ["home", "search"]; // MBS pages we can show the status count on
